import { render, staticRenderFns } from "./NonIntegrated.vue?vue&type=template&id=dc869bfa&scoped=true&"
import script from "./NonIntegrated.vue?vue&type=script&lang=js&"
export * from "./NonIntegrated.vue?vue&type=script&lang=js&"
import style0 from "./NonIntegrated.vue?vue&type=style&index=0&id=dc869bfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc869bfa",
  null
  
)

export default component.exports